/**
 * NumbersPanel.tsx — the `#numbers*` route's wrapper. `#numbers` renders the
 * Number page; `#numbers/products` (the sidebar's Products entry) renders the
 * Products page. No tab strip: each page is reached from the sidebar.
 */

import type { ApiClient } from '../../api/client';
import { ProductsPage } from '../products/ProductsPage';
import { NumbersPage } from './NumbersPage';

export interface NumbersPanelProps {
  apiClient: ApiClient;
  activeTab: 'number' | 'products';
}

export const NumbersPanel = ({ apiClient, activeTab }: NumbersPanelProps) =>
  activeTab === 'products' ? (
    <ProductsPage apiClient={apiClient} />
  ) : (
    <NumbersPage apiClient={apiClient} />
  );
